import React from 'react';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import getSymbolFromCurrency from 'currency-symbol-map';

import messages from './messages';
import { extractAllocationStatistics } from '../utils';

import ProgressRadialBar from 'components/charts/ProgressRadialBar';
import Tooltip from 'components/Tooltip';

/* stylelint-disable no-descending-specificity */
const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    & > div {
        &:not(:last-child) {
            margin-right: 10px;
        }
    }
`;

const TitleAndDateCell = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;

    & > div {
        &:first-child {
            margin-right: 10px;
            font-weight: bold;
        }
        &:last-child {
            font-size: 12px;
        }
    }
`;

const SegmentCell = styled.div`
    flex: 1;
    white-space: nowrap;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const StatisticsCell = styled.div`
    flex: 3;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
        flex: 1;
    }
`;

const BlockItemHeader = (props) => {
    const intl = useIntl();
    const { name, startDate, endDate, marketCode, currency } = props;
    const { blockedRoomCount, revenueSold, roomsSold, estimatedRevenueTotal } = extractAllocationStatistics(props);

    return (
        <Row>
            <TitleAndDateCell>
                <div>{name}</div>
                <div>
                    <FormattedMessage
                        {...messages.fromToDate}
                        values={{
                            from: <FormattedDate value={startDate} day="2-digit" month="short" year="numeric" />,
                            to: <FormattedDate value={endDate} day="2-digit" month="short" year="numeric" />,
                        }}
                    />
                </div>
            </TitleAndDateCell>

            <SegmentCell>
                <Tooltip title={marketCode}>{marketCode}</Tooltip>
            </SegmentCell>

            <StatisticsCell>
                <div>
                    <ProgressRadialBar
                        id="roomsProgressRadialBar"
                        value={roomsSold}
                        total={blockedRoomCount}
                        size={100}
                        formatValue={(value) => intl.formatNumber(value)}
                        renderValue={(value) =>
                            intl.formatMessage(messages.roomCountLabel, {
                                value,
                            })
                        }
                    />
                </div>
                <div>
                    <ProgressRadialBar
                        id="revenueProgressRadialBar"
                        value={revenueSold}
                        total={estimatedRevenueTotal}
                        size={100}
                        formatValue={(value) => {
                            const currencySymbol = getSymbolFromCurrency(currency);
                            const currencyValue = intl.formatNumber(value / 100, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            });

                            return `${currencySymbol}${currencyValue}`;
                        }}
                    />
                </div>
            </StatisticsCell>
        </Row>
    );
};

export default BlockItemHeader;
